export const uk = {
    'name-cis-time-zone': 'СНГ',
    'name-russia-time-zone': 'Россия',
    'name-world-time-zone': 'Страны мира'
};
